import { useEffect, useState, useContext } from "react"
import { getUrgencyLaw } from "../../services/beds"
import CardBeds from "../../components/CardBeds"
import { expiredToken } from "../../utils/expiredToken"
import DashboardUnit from "../../contexts/dashboardUnitContext"

export default function UrgencyLaw() {
  const [subServices, setSubServices] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const { setDateUpdate, detailsUnit } = useContext(DashboardUnit)

  useEffect(() => {
    getService()
  }, [detailsUnit])

  const getService = async () => {
    setIsLoading(true)
    try {
      const ser = await getUrgencyLaw()
      setSubServices(ser.subServices)
    } catch (error) {
      console.log(error)
      if (error?.status === 401) {
        expiredToken()
      }
    } finally {
      setIsLoading(false)
    }
  }

  const style = {
    color: "#4CAF50",
    width: "100%",
    padding: "10px",
    fontSize: "20px",
  }
  const flex = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
  }
  return (
    <>
      <div style={flex}>
        {subServices &&
          subServices.map((subService, idx) => (
            <>
              <div style={style} key={idx}>
                {subService.name}
              </div>
              {subService.beds && subService.beds.map((bed, index) => <CardBeds data={bed} key={`${index}-bed`} />)}
            </>
          ))}
      </div>
    </>
  )
}
